import * as React from 'react';
import SummaryTimeline from '../../components/timelines/Summary'
import Log from '../../components/Log'
import { CommentCreateWidget } from './utils/CommentDialog'
import InstrumentStaticNotes from './utils/InstrumentStaticNotes'
import PartialHeaders from './utils/PartialHeaders'
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button'
import DiagnosisPlot from '../../components/DiagnosisPlot'
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useVisibleQuery } from '../../apollo/VisibleQuery'
import NetworkLoader from '../../components/NetworkLoader'
import {
    GET_INSTRUMENT_COMMENTS,
    GET_INSTRUMENT_DEPLOYMENTS,
    GET_INSTRUMENT_HARDWARESTATUS,
    GET_INSTRUMENT_ISSUES,
    GET_INSTRUMENT_STATI
} from '../../apollo/queries/instruments'

const formatInfoLogsDate = date => {
    const year = date.getFullYear()
    const month = `${date.getMonth() + 1}`.padStart(2, '0')
    const day = `${date.getDate()}`.padStart(2, '0')
    return `${year}${month}${day}`
}





class InstrumentDetail extends React.PureComponent {

    handleDataCheckerLink = () => {
        const { panId, deployment } = this.props.data;

        const locationName = deployment && deployment[0] ? deployment[0].location.name : 'NoLocation';
        window.open(`https://datachecker.pandonia-global-network.org/Operational/P${panId}s1/${locationName}.html`, '_blank');
    };
    handleInstrumentDetailLink = () => {
        const { panId } = this.props.data;
        window.open(`https://hetzner.pandonia-global-network.org/instrument_details/${panId}`, '_blank');
    }
    handleInfoLogsLink = () => {
        const { panId } = this.props.data;
        const dateEnd = new Date()
        const dateIni = new Date(dateEnd)
        dateIni.setDate(dateEnd.getDate() - 3)
        const params = new URLSearchParams({
            instr_type: 'Pandora',
            pan_id: panId,
            date_ini: formatInfoLogsDate(dateIni),
            date_end: formatInfoLogsDate(dateEnd)
        })
        window.open(`https://infologs.pandonia-global-network.org/?${params.toString()}`, '_blank');
    }
    render() {
        const { data, user, commentsQuery } = this.props
        return (
            <Paper style={{flex: '1', flexDirection: 'column', display: 'flex', padding: 16, boxSizing: 'border-box'}}>
                <SummaryTimeline style={{margin: 'auto', marginBottom: '50'}} size={[1100, 50]}
                                 data={data} daysDelta={365} />
                <div style={{flex: '1', display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 12}}>
                    <CommentCreateWidget user={user} panID={data.panId} instrumentId={data.id} />
                    <PartialHeaders panID={data.panId} instrumentID={data.id} />
                    {data.deployment[0] ?
                        <DiagnosisPlot panID={data.panId} location={data.deployment[0].location.name} /> :
                        null
                    }
                    <Button variant="outlined" onClick={this.handleDataCheckerLink} endIcon={<OpenInNewIcon />}>Data Checker</Button>
                    <Button variant="outlined" onClick={this.handleInstrumentDetailLink} endIcon={<OpenInNewIcon />}>Instrument Detail</Button>
                    <Button variant="outlined" onClick={this.handleInfoLogsLink} endIcon={<OpenInNewIcon />}>Info Logs</Button>
                </div>
                <InstrumentStaticNotes data={data} user={user}/>
                {commentsQuery.error && !commentsQuery.data ? <p>Error loading comments</p> :
                    commentsQuery.loading && !commentsQuery.data ? <NetworkLoader compact label="Loading comments…" /> :
                        <Log data={data} user={user} />}
            </Paper>
        )
    }
}

export default function InstrumentSummary({ data, user }) {
    const options = { variables: { input: data.id }, pollInterval: 180000 }
    // These queries are independent: start all of them before rendering a loader.
    const deployments = useVisibleQuery(GET_INSTRUMENT_DEPLOYMENTS, options)
    const hardware = useVisibleQuery(GET_INSTRUMENT_HARDWARESTATUS, options)
    const stati = useVisibleQuery(GET_INSTRUMENT_STATI, options)
    const issues = useVisibleQuery(GET_INSTRUMENT_ISSUES, options)
    const comments = useVisibleQuery(GET_INSTRUMENT_COMMENTS, options)

    const sections = [
        [deployments, 'deployments'],
        [hardware, 'hardware status'],
        [stati, 'status assignments'],
        [issues, 'issues']
    ]
    // A catch-up refresh can fail after a background visit. Keep the loaded
    // detail mounted so reading position and unfinished comments survive.
    const failed = sections.find(([result]) => result.error && !result.data)
    if (failed) return <p>Error loading {failed[1]}</p>
    const pending = sections.find(([result]) => result.loading && !result.data)
    if (pending) return <NetworkLoader compact label={`Loading ${pending[1]}…`} />

    const fullData = {
        ...data,
        deployment: deployments.data?.instrument?.deployment || [],
        hardwarestatus: hardware.data?.instrument?.hardwarestatus || [],
        stati: stati.data?.instrument?.stati || [],
        issues: issues.data?.instrument?.issues || [],
        comments: comments.data?.instrument?.comments || []
    }

    return <InstrumentDetail data={fullData} user={user} commentsQuery={comments} />
}
